export const TBTC_INFORMATION_URL = "https://x.com/GMX_IO/status/1833896397709463921";

export const isTbtcIncentivizedMarket = function (marketAddress: string) {
  return marketAddress === "0xd62068697bCc92AF253225676D618B0C9f17C663";
};
